// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type AufgabenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SearchAufgabenQuery = {
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSearchAufgaben(): (
  query: SearchAufgabenQuery
) => Promise<AufgabenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) =>
      (await getAPI()).aufgaben.searchAufgaben({ ...query }),
    [getAPI]
  );
}
